import React from 'react';

const HeroSection = () => {
  return (
    <section className="relative h-screen bg-cover bg-center bg-no-repeat overflow-hidden" 
             style={{ backgroundImage: 'url(/assets/images/banner/join_us1.jpg)' }}>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white max-w-4xl mx-auto px-6">
          <div className="space-y-6">
            <h1 className="text-5xl lg:text-7xl font-bold leading-tight animate-fade-in-up">
              Join Our
              <span className="block text-secondary animate-fade-in-up animation-delay-300"> Circle</span>
            </h1>
            <p className="text-xl lg:text-3xl font-light leading-relaxed animate-fade-in-up animation-delay-600 max-w-3xl mx-auto">
              Become part of a community dedicated to service, leadership, and making a lasting impact
            </p>
            <div className="text-lg lg:text-xl text-gray-200 animate-fade-in-up animation-delay-900">
              Where passion meets purpose
            </div>
          </div>
        </div>
      </div>
      
      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 1s ease-out forwards;
          opacity: 0;
        }
        
        .animation-delay-300 {
          animation-delay: 0.3s;
        }
        
        .animation-delay-600 {
          animation-delay: 0.6s;
        }
        
        .animation-delay-900 {
          animation-delay: 0.9s;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;